<template>
    <div>
        <h1 class="title">Leistungen</h1>

        <p>Meine Kanzlei bietet umfangreiche Leistungen und individuelle Beratung in allen steuerlichen Fragen an. Die
            folgende Liste liefert einen beispielhaften Auszug meiner Tätigkeiten. Für Fragen und Beratung stehe ich
            Ihnen gerne zur Verfügung.</p><br/>
        <ul>
            <li>Einrichtung einer Buchführung</li>
            <li>Buchführung</li>
            <li>Betriebswirtschaftliche Beratung</li>
            <li>Lohnabrechnung</li>
            <li>Abschlussarbeiten</li>
            <li>Steuererklärungen, z.B. Einkommensteuererklärung, auch zB Einkommenssteuererklärung für Arbeitnehmer mit
                Auslandsbezug
            </li>
            <li>Prüfung von Steuerbescheiden</li>
            <li>Teilnahme an Prüfungen, wie z.B. einer Außenprüfung</li>
            <li>Rechtsbehelfe</li>
            <li>Steuerberatung im Vorhinein</li>
            <li>Beurteilung eines Vorhabens aus steuerlicher Sicht</li>
            <li>und weitere</li>
        </ul>
        <br/>
        <p>Dies ist eine beispielhafte Aufzählung.</p><br/>
        <p>
            Die Kosten für die o.g. Leistungen werden auf der Grundlage der Steuerberatervergütungsverordnung (StBVV)
            berechnet.
        <p/>
        Kostenangebote werden gerne erstellt.
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        }
    }
</script>